import React from 'react';
import cn from 'classnames';
import Table from '../../table';
import IndexTableFooter from './footer';
import IndexTableHeader from './header';

const IndexTable = ({ tableHeaders, children, selectable, className }) => (
  <Table
    className={cn('Index-table', {
      [className]: className,
    })}
    role="table"
    alternate
    noBorderTop
    roundedBottom
  >
    <IndexTableHeader selectable={selectable} tableHeaders={tableHeaders} />
    {children}
    <IndexTableFooter />
  </Table>
);

IndexTable.defaultProps = {
  selectable: true,
};

export default IndexTable;
